import { IEnvironment } from "./environment.interface";

export const environment: IEnvironment = {
  production: false,
  env: 'dev',
  apiUrl: 'https://iea-api-dev.innate.ly/api',
  // apiUrl: 'https://accessiea-api.innate.ly/api',
  arenaEqAppUrl: 'https://arenaeq-dev.innate.ly',
  paypalClientId: 'AbG-mNyfCH7e-FBZ5lOzO7WEr-peyBrZyEa7Ve7fOOmV2vgvDSXiAXTcG3kGhvgLxS40NO5XsOyhRRah',
  paypalInnatelyClientId: 'AZoq57245RHqQa4XpXYiG1ljSvI00CXkM-NVEwN5PmYaXJ3G-AvVBEeihqsjAK1yJSJiUa547d3GoSdA',
  paypalInnatelyVendorClientId: 'AXzKikEVPofYgL5agG3luC6gkmvJHsTzAMu_xxAGEzfeIgchZEcpC_ZxpTRB2y67G-KIjbX3uSvovzxQ',
  quizTestId: 2199330,
  IEAQuizUrl: 'https://www.classmarker.com/online-test/start/?quiz=t99660540ff5f84e',
  SafeSportUrl: 'https://www.rideiea.org/forms/safesport/',
  appName: "ieaApp",
  infoRideieaEmail: "info@rideiea.org"
};
